/**
 * Route helpers for mobile Planning Engine surfaces.
 */

export const ENGINE_BASE = '/planning/engine';

export const ENGINE_INPUT_ROUTES = [
  { path: 'scenarios', label: 'Scenarios', description: 'Planning assumptions and horizon' },
  { path: 'priorities', label: 'Priorities', description: 'Ranked items and estimates' },
  { path: 'work-units', label: 'Work Units', description: 'Decomposed work breakdown' },
  { path: 'dependencies', label: 'Dependencies', description: 'Blocking relationships' },
  { path: 'capacity', label: 'Resource Budget', description: 'Available capacity by type' },
  { path: 'participation', label: 'Participation', description: 'Team commitment requirements' },
  { path: 'time-phased', label: 'Time-Phased', description: 'Supply calendar and workload templates' },
  { path: 'funding', label: 'Funding & Costs', description: 'Approved envelope and launch cost plans' },
] as const;

export const ENGINE_RESULT_ROUTES = [
  { path: 'engine-output', label: 'Engine Output', description: 'Full plan decisions, one row per priority' },
  { path: 'achievability', label: 'Achievability', description: 'Priority feasibility status' },
  { path: 'above-below', label: 'Above / Below', description: 'Line-of-plan communication view' },
  { path: 'summary', label: 'Summary', description: 'Aggregated executive summary' },
  { path: 'outcomes', label: 'Outcomes', description: 'Items by decision category' },
  { path: 'compare', label: 'Compare', description: 'Scenario feasibility comparison' },
  { path: 'run-history', label: 'Run History', description: 'Every past run, by scenario and scope' },
] as const;

export function engineSubPath(pathname: string): string {
  if (!pathname.startsWith(ENGINE_BASE)) return '';
  return pathname.slice(ENGINE_BASE.length).replace(/^\/+/, '');
}

export function engineHref(path: string): string {
  return path ? `${ENGINE_BASE}/${path}` : ENGINE_BASE;
}

const ENGINE_ROUTE_TITLES: Record<string, string> = {
  '': 'Planning Engine',
  scenarios: 'Scenarios',
  priorities: 'Priorities',
  'work-units': 'Work Units',
  dependencies: 'Dependencies',
  capacity: 'Resource Budget',
  participation: 'Participation',
  'time-phased': 'Time-Phased',
  funding: 'Funding & Costs',
  'engine-output': 'Engine Output',
  achievability: 'Achievability',
  'above-below': 'Above / Below',
  summary: 'Summary',
  outcomes: 'Outcomes',
  compare: 'Compare',
  'run-history': 'Run History',
};

export function resolveEngineTitle(pathname: string): string | null {
  if (!pathname.startsWith(ENGINE_BASE)) return null;
  const sub = engineSubPath(pathname);
  return ENGINE_ROUTE_TITLES[sub] ?? 'Planning Engine';
}
